//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { EmailCapture } from '@fc/angie-ui';

export default {
  name: 'StayInTheKnow',
  components: {
    EmailCapture,
  },
  data() {
    return {
      errors: [],
      isSubmitted: false,
    };
  },
  computed: {
    socialIcons() {
      return [
        { name: 'facebook', url: 'https://www.facebook.com/fightcamp/' },
        { name: 'instagram', url: 'https://www.instagram.com/fightcamp/' },
        { name: 'youtube', url: 'https://www.youtube.com/fightcamp/' },
      ];
    },
  },
  methods: {
    async submitEmail(email) {
      const res = await this.$api_client.validateEmail(email.toLowerCase());

      if (!res.emailValid) {
        this.errors.push('Invalid Email. Please check for errors or try with another email.');
      } else {
        this.errors = [];
        this.isSubmitted = true;

        this.$ecommAnalytics.identifyByEmail(email);
        this.$analytics.emailIdentified(email);

        this.$analytics.campaignSubscribed({
          name: 'AboutUsSubscribe',
          type: 'page',
          email,
        });
      }
    },
  },
};
